export const GOVMETRIC_URL = 'https://websurveys2.govmetric.com';
